import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import _ from "lodash";
import { IMAGE_PATH, itemCount, COMMON_FAIL_MESSAGE } from "Constants";
import { Modal } from "react-bootstrap";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import Button from "react-bootstrap-button-loader";
import FormBuilder from "../../../tickets/components/form-builder/form-builder";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  saveForm,
  updateFomeName,
  updateFormList,
  formEdited,
} from "FormBuilderAction";
import {
  openProposalForm,
  updateProposal,
  fetchProposalForm,
} from "ProposalAction";
import LocaleStrings from "Languages";

class EditForm extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {}

  onSubmitForm = (values) => {
    var { oldKeys, formName, editProposalModal } = this.props;
    var formnumber = editProposalModal.proposalform.formnumber;
    let version = editProposalModal.proposalform.versionno;
    var newVersion = parseInt(version) + 1;
    var formid = editProposalModal.proposalform.formid;

    // Rearrange the taborder if any field is removed or added
    var newArrAvailable = [];
    oldKeys.map((value, index) => {
      newArrAvailable.push({ ...value, taborder: index + 1 });
    });
    var oldKeys = newArrAvailable;

    let unique = [...new Set(oldKeys.map((a) => a.name))]; // Check unique field
    let name_email = _.filter(oldKeys, (obj) => {
      return (
        obj.name.toLowerCase() == "firstname" ||
        obj.name.toLowerCase() == "lastname" ||
        obj.name.toLowerCase() == "email"
      );
    }); // Checking if name or email exist or not

    if (name_email.length > 0) {
      this.props.showError(
        LocaleStrings.dynamic_form_validation_name_email_field_not_required
      );
    } else if (unique.length != oldKeys.length) {
      this.props.showError(
        LocaleStrings.dynamic_form_validation_all_field_should_unique
      );
    } else {
      var formvalues = {
        formid: formid,
        formname: formName,
        formnumber: formnumber,
        versionno: newVersion,
        formtype: "proposal",
        formjson: JSON.stringify(oldKeys),
        ispublished: editProposalModal.proposalform.ispublished,
        ismandatory: editProposalModal.proposalform.ismandatory,
      };

      this.setState({ loading: true });
      this.props.saveForm(this.props.session, formvalues, (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          let newformid = response.data.newformid;
          if (newformid) {
            values.formid = newformid;
            values.proposalid =
              editProposalModal.proposalform &&
              editProposalModal.proposalform.proposal_by_formid
                ? editProposalModal.proposalform.proposal_by_formid[0]
                    .proposalid
                : "";
            this.props.updateProposal(
              this.props.session,
              values,
              (response) => {
                if (response.success === 0) {
                  this.setState({ loading: false });
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.setState({ loading: false });
                  this.props.showSuccess(
                    LocaleStrings.proposal_form_updated_success
                  );
                  this.props.fetchProposalForm(this.props.session);
                }
              }
            );
          }
          this.closeModal();
        }
      });
    }
  };

  closeModal() {
    this.props.formEdited(true);
    this.props.openProposalForm(false, {});
  }

  renderCustomTextarea(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12 m-0 mb-5">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>{" "}
          <span style={{ fontSize: 10 }}>
            (
            {
              LocaleStrings.tickets_ticket_form_label_ticket_description_extra_text
            }
            )
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <textarea
            className="form-control"
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            {...field.input}
            disabled={field.disabled}
            style={{ height: 75 }}
          ></textarea>
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 m-0 mb-5";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      oldKeys,
      editProposalModal,
      formChanged,
    } = this.props;
    //console.log('formjson',editProposalModal.proposalform.formjson);
    //console.log('oldKeys',oldKeys);
    return (
      <div>
        <Modal
          className="modal-container modalResize"
          enforceFocus={false}
          show={this.props.editProposalModal.showModal === true ? true : false}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.dynamic_form_text_update_form}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <div className="col-md-8 mb-15" style={{ marginLeft: "-15px" }}>
                <Field
                  name="proposal_name"
                  label={LocaleStrings.proposal_name}
                  placeholder={LocaleStrings.proposal_name}
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  // disabled={this.props.editMode}
                />
              </div>
              <div className="col-md-8 mb-15" style={{ marginLeft: "-15px" }}>
                <Field
                  name="proposaldesc"
                  label={LocaleStrings.proposal_description}
                  placeholder={LocaleStrings.proposal_description}
                  component={this.renderCustomTextarea}
                  mandatory="true"

                  // disabled={this.props.editMode}
                />
              </div>
              <div className="col-md-8 mb-15" style={{ marginLeft: "-15px" }}>
                <Field
                  name="category"
                  label={LocaleStrings.proposal_category}
                  placeholder={LocaleStrings.proposal_category}
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  // disabled={this.props.editMode}
                />
              </div>
              <div className="scrollable-modal">
                <FormBuilder
                  source="proposal"
                  version={editProposalModal.proposalform.versionno}
                />
              </div>

              <div className="" style={{ padding: "24px" }}>
                <b className="form-name">{LocaleStrings.note} :- </b>{" "}
                <p className="form-subheading">
                  {LocaleStrings.dynamic_form_note1}
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                bsStyle=""
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.proposal_form_button_update}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  var initVals = {};
  if (state.editProposalModal.proposalform) {
    initVals =
      state.editProposalModal.proposalform &&
      state.editProposalModal.proposalform.proposal_by_formid
        ? state.editProposalModal.proposalform.proposal_by_formid[0]
        : {};
  }

  return {
    session: state.session,
    oldKeys: state.formList,
    formName: state.formName,
    formChanged: state.formChanged,
    editProposalModal: state.editProposalModal,
    initialValues: initVals,
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var proposal_name = values["proposal_name"];
  var proposaldesc = values["proposaldesc"];

  if (!proposal_name) {
    errors["proposal_name"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }
  if (!proposaldesc) {
    errors["proposaldesc"] =
      LocaleStrings.tickets_ticket_form_validation_required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  openProposalForm,
  saveForm,
  updateFomeName,
  updateFormList,
  showError,
  showSuccess,
  formEdited,
  updateProposal,
  fetchProposalForm,
})(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditForm)
);
